import { Component, OnInit } from "@angular/core";
import { AccountService } from "src/app/dashboard/services/account.service";
import { FormGroup, FormControl } from "@angular/forms";
import Swal from "sweetalert2";

@Component({
  selector: "app-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.css"],
})
export class ReportComponent implements OnInit {
  isWithdrawCancelLoading: boolean = false;

  depositList: {
    date: Date;
    login: number;
    amount: number;
    status: string;
    currency: string;
    gateway: string;
    amount_updated: number;
  }[] = null;
  withdrawList: {
    date: Date;
    login: number;
    order_id: string;
    amount: number;
    status: string;
    currency: string;
    gateway: string;
    amount_updated: number;
  }[] = null;
  internalTransferList: {
    date: Date;
    from_login: number;
    to_login: number;
    amount: number;
    status: string;
    from_currency: string;
    to_currencygateway: string;
  }[] = null;

  // Pagination //
  limits: number[] = [10, 20, 30, 40, 50, 100];
  math = Math;

  depositLimitForm: FormGroup;
  deposit_current_page: number = 1;
  deposit_limit: number = 10;
  deposit_total: number = 0;

  withdrawLimitForm: FormGroup;
  withdraw_current_page: number = 1;
  withdraw_limit: number = 10;
  withdraw_total: number = 0;

  itLimitForm: FormGroup;
  it_current_page: number = 1;
  it_limit: number = 10;
  it_total: number = 0;
  // Pagination //

  constructor(private account: AccountService) {}
  ngOnInit() {
    // Pagination //
    this.depositLimitForm = new FormGroup({
      limitSelected: new FormControl(10),
    });

    this.depositLimitForm
      .get("limitSelected")
      .valueChanges.subscribe((value) => {
        if (value) {
          this.deposit_limit = value;
          if (
            this.deposit_limit * this.deposit_current_page >
            this.deposit_total
          )
            this.deposit_current_page = 1;
          this.getDepositList();
        }
      });

    this.withdrawLimitForm = new FormGroup({
      limitSelected: new FormControl(10),
    });

    this.withdrawLimitForm
      .get("limitSelected")
      .valueChanges.subscribe((value) => {
        if (value) {
          this.withdraw_limit = value;
          if (
            this.withdraw_limit * this.withdraw_current_page >
            this.withdraw_total
          )
            this.withdraw_current_page = 1;
          this.getWithdrawList();
        }
      });

    this.itLimitForm = new FormGroup({
      limitSelected: new FormControl(10),
    });
    this.itLimitForm.get("limitSelected").valueChanges.subscribe((value) => {
      if (value) {
        this.it_limit = value;
        if (this.it_limit * this.it_current_page > this.it_total)
          this.it_current_page = 1;
        this.getInternalTransfer();
      }
    });
    // Pagination //

    this.getDepositList();
    this.getWithdrawList();
    this.getInternalTransfer();
  }

  getDepositList() {
    // let pagination: { current: number; limit: number } = {
    //   current: this.deposit_current_page,
    //   limit: this.deposit_limit,
    // };
    // this.account.getDepositList(pagination).subscribe((response) => {
    //   if (response.request_status) {
    //     this.depositList = response.data.deposit;
    //     this.deposit_total = response.data.total;
    //   }
    // });
  }

  getWithdrawList() {
    // let pagination: { current: number; limit: number } = {
    //   current: this.withdraw_current_page,
    //   limit: this.withdraw_limit,
    // };
    // this.account.getWithdrawList(pagination).subscribe((response) => {
    //   if (response.request_status) {
    //     this.withdrawList = response.data.withdraw;
    //     this.withdraw_total = response.data.total;
    //   }
    // });
  }

  getInternalTransfer() {
    // let pagination: { current: number; limit: number } = {
    //   current: this.it_current_page,
    //   limit: this.it_limit,
    // };
    // this.account.getInternalTransferList(pagination).subscribe((response) => {
    //   if (response.request_status) {
    //     this.internalTransferList = response.data.internaltransfer;
    //     this.it_total = response.data.total;
    //   }
    // });
  }

  // Pagination methods //
  Next(current: number, total: number, limit: number, type: number) {
    if (current < this.math.ceil(total / limit)) {
      current += 1;
      this.getReport(type);
    }
  }
  Previous(current: number, type: number) {
    if (current > 1) {
      current -= 1;
      this.getReport(type);
    }
  }

  First(current: number, type: number) {
    if (current !== 1) {
      current = 1;
      this.getReport(type);
    }
  }
  Last(current: number, total: number, limit: number, type: number) {
    if (current !== this.math.ceil(total / limit)) {
      current = this.math.ceil(total / limit);
      this.getReport(type);
    }
  }

  getReport(type: number) {
    if (type === 1) this.getDepositList();
    if (type === 2) this.getWithdrawList();
    if (type === 3) this.getInternalTransfer();
  }
  // Pagination methods //

  cancelWithdraw(login: number, order_id: string) {
    this.isWithdrawCancelLoading = true;

    let formData: { login: number; order_id: string } = {
      login: login,
      order_id: order_id,
    };

    this.account.cancelWithdraw(formData).subscribe(
      (response) => {
        if (response.request_status) {
          Swal.fire("Withdraw Cancelled", "", "success");
          this.getWithdrawList();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
        this.isWithdrawCancelLoading = false;
      },
      (error) => {
        this.isWithdrawCancelLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }
}
